import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-error-bank-account',
  templateUrl: './modal-error-bank-account.component.html',
  styleUrls: ['./modal-error-bank-account.component.scss']
})
export class ModalErrorBankAccountComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalErrorBankAccountComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { multipoint: boolean; accounts?: string[]; },
  ) { }

  public closeDialog(event: boolean): void {
    this.dialogRef.close(event);
  }
}
